import { render, staticRenderFns } from "./Administrative.vue?vue&type=template&id=e1c62e6e&"
import script from "./Administrative.vue?vue&type=script&lang=js&"
export * from "./Administrative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports